var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRuleSetModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.29412 9H7.43958C6.97342 9 6.74034 9 6.52099 9.05425C6.32653 9.10236 6.14062 9.1817 5.9701 9.28936C5.77776 9.41079 5.61294 9.58058 5.28332 9.92018L3.89315 11.3525C3.56353 11.6921 3.39871 11.8619 3.28085 12.0601C3.17636 12.2357 3.09935 12.4273 3.05266 12.6277C3 12.8536 3 13.0939 3 13.5741V17.8582C3 18.9579 3 19.5077 3.20773 19.9279C3.39045 20.2973 3.68202 20.5977 4.04063 20.786C4.44832 21 4.98202 21 6.04941 21H17.9506C19.018 21 19.5516 21 19.9594 20.786C20.318 20.5977 20.6095 20.2973 20.7923 19.9279C21 19.5077 21 18.9579 21 17.8582V13.5741C21 13.0939 21 12.8536 20.9474 12.6277C20.9007 12.4273 20.8236 12.2357 20.7192 12.0601C20.6012 11.8619 20.4365 11.6921 20.1069 11.3525L18.7166 9.92018C18.387 9.58058 18.2223 9.41079 18.0299 9.28936C17.8594 9.1817 17.6735 9.10236 17.479 9.05425C17.2597 9 17.0266 9 16.5605 9H15.7059",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.5H18.291C17.5544 13.5 17.186 13.5 16.9087 13.6888C16.6315 13.8775 16.515 14.2075 16.2821 14.8675L16.1885 15.1325C15.9556 15.7925 15.8391 16.1225 15.5619 16.3112C15.2846 16.5 14.9162 16.5 14.1796 16.5H9.82043C9.08379 16.5 8.71547 16.5 8.43817 16.3112C8.16088 16.1225 8.04441 15.7925 7.81145 15.1325L7.71796 14.8675C7.48501 14.2075 7.36854 13.8775 7.09124 13.6888C6.81395 13.5 6.44562 13.5 5.70898 13.5H3",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.5H14.7C14.8657 6.5 15 6.6343 15 6.8V10.2C15 10.3657 14.8657 10.5 14.7 10.5H9.3C9.13431 10.5 9 10.3657 9 10.2V6.8C9 6.6343 9.13431 6.5 9.3 6.5H10M14 6.5V5C14 4.33333 13.6 3 12 3C10.4 3 10 4.33333 10 5V6.5M14 6.5H10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuleSetModalIcon);
export default __webpack_public_path__ + "static/media/ruleSetModalIcon.2c27244e3d99260502ce36b31e73e181.svg";
export { ForwardRef as ReactComponent };